import { Col, Form, Modal, Row } from 'antd';
import React, { useState } from 'react'
import { backendGetRequest } from '../../../../../../helpers/callBackend';
import { downloadPDF } from '../../../../../../helpers/downloadPDF';
import Button from '@mui/material/Button';
import LoadingButton from '@mui/lab/LoadingButton';

const DownloadVerificationDocs = (props) => {
    const [selectedRows, setSelectedRows] = useState(props.selectedRows)

    const deleteRow = (bankAccountId) => {

        const selectedAccounts = selectedRows.filter((account) => {
            return account.bankId !== bankAccountId
        })

        setSelectedRows(selectedAccounts)
    }

    const downloadVerificationDoc = () => {
        selectedRows.forEach((account) => {
            if (account.source === "UN") {
                backendGetRequest(
                    "/api/bank-account/verification-document",
                    { params: { bank_account_id: account.bankId } },
                    "loading",
                ).then((res) => {
                    const d = res?.data;
                    downloadPDF(d, "verification-document.pdf");
                })
              }
            
        });
    };

  return (
    <Modal
                footer={null}
                width={800}
                title="Download Verification Document"
                visible={props.visible}
                onCancel={props.handleCancelModal}
            >
                <div>
                    <h3 style={{ marginBottom: "18px" }}>
                        Which accounts verification document would you like to download?
                    </h3>

                    <Form>
                        {selectedRows.map((account) => {
                            return (
                                <Row
                                    gutter={2}
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                    }}
                                >
                                    <Col
                                        span={8}
                                    >
                                        <Form.Item>{account.account}</Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        {account.source === "UN" ? (
                                            <Form.Item>
                                                Verification document is available for download
                                            </Form.Item>
                                        ) : (
                                            <Form.Item>
                                                Sorry, can only do multiple
                                                downloads for Arpari accounts
                                            </Form.Item>
                                        )}
                                    </Col>

                                    <Col
                                        span={4}
                                        style={{
                                            display: "flex",
                                            justifyContent: "flex-end",
                                        }}
                                    >
                                        <Form.Item>
                                            <Button
                                                disableElevation fullWidth size="small" variant="outlined" color="secondary"
                                                sx={{ fontSize: 14, width: '100%', textTransform: 'none' }}
                                                onClick={() => {
                                                    deleteRow(
                                                        account.bankId
                                                    );
                                                }}
                                            >
                                                Remove
                                            </Button>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            );
                        })}

                        <Form.Item>
                            <LoadingButton
                                htmlType="submit"
                                style={{ marginTop: "16px" }}
                                loadingPosition='start'
                                disabled={selectedRows.length === 0}
                                onClick={downloadVerificationDoc} disableElevation fullWidth size="small" type="submit" variant="contained" color="primary"
                                sx={{ fontSize: 14, width: '100%', textTransform: 'none' }}
                            >
                                Download Verification Document
                            </LoadingButton>
                        </Form.Item>
                    </Form>
                </div>
            </Modal>
  )
}

export default DownloadVerificationDocs